import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import {H3} from "@irati/ui/src/Typography/Heading"
import {Para as BasePara} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"

import {Content, Icon, Card} from "./styled/Card"

const Para = styled(BasePara)`
  padding: 5px 0 0;
`

const EmptyCard = ({onClick, title, desc, img, color}) => {
  return (
    <Card color={color} onClick={onClick} tiny>
      <Icon src={img} />
      <Content>
        <H3>
          <FormattedMessage id={title} />
        </H3>
        <Para>
          <FormattedMessage id={desc} />
        </Para>
      </Content>
    </Card>
  )
}

EmptyCard.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

EmptyCard.defaultProps = {
  onClick: null
}

export default EmptyCard
